import React, { useEffect, useState, useCallback } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import refurbishmentIcon from "../../../../../assets/new-product-detail-cats/header-icons/prod-deliveries-icon.svg";
import { useTranslation } from "react-i18next";
import formatDate from "../../components/HeaderBox/formatDate";
import { getRefurbishment41_5Totals } from "../../../../../apis/Product/UseStageFlow41Api";

const Refurbishment41_5Icon = () => (
  <img src={refurbishmentIcon} alt="Refurbishment Icon" width={76} height={76} />
);

const Refurbishment41_5Header = ({
  className,
  leftBoxProps,
  rightBoxProps,
  productId,
  show,
  refreshTrigger,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalRefurbishmentItem, setTotalRefurbishmentItem] = useState(null);

  const fetchTotals = useCallback(() => {
    if (productId) {
      getRefurbishment41_5Totals({
        productId,
        setTotals: setTotalRefurbishmentItem,
      });
    }
  }, [productId]);

  useEffect(() => {
    fetchTotals();
  }, [fetchTotals, refreshTrigger]);

  // Listen for refresh events from table components
  useEffect(() => {
    const handleRefresh = () => {
      fetchTotals();
    };
    
    window.addEventListener('refresh-refurbishment-41-5-totals', handleRefresh);
    
    return () => {
      window.removeEventListener('refresh-refurbishment-41-5-totals', handleRefresh);
    };
  }, [fetchTotals]);

  return (
    <CategoryComponent
      show={show}
      className={`refurbishment-41-5-category ${className || ""}`}
      leftBoxProps={{
        icon: <Refurbishment41_5Icon />,
        title: t("REFURBISHMENT_41_5") || "Refurbishment",
        description:
          t("REFURBISHMENT_41_5_DESC") ||
          "A process that restores or upgrades a product to extend its service life. This may include disassembly, replacement of key components, reassembly and performance testing.",
        productId: productId,
        isSystemBoundary: true,
        customTextColor: "white",
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_LIFECYCLE_PHASE"),
            items: [
              {
                subtitle: "",
                subitems: [],
              },
            ],
            isSwitchable: true,
          },
          // {
          //   title: t("TOTAL_FOR_FLOW_41_5") || "Total for Flow 41.5",
          //   items: [
          //     {
          //       subtitle: "",
          //       subitems: [],
          //     },
          //   ],
          //   isSwitchable: true,
          // },
        ],
        impactTotals: totalRefurbishmentItem?.impact_totals || null,
        lastUpdated: totalRefurbishmentItem?.updated_at
          ? formatDate(totalRefurbishmentItem?.updated_at)
          : t("DD_MM_YYYY"),
        customTextColor: "white",
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default Refurbishment41_5Header;

